




























































import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import ViewWrapper from '~/components/shared/classified/view/ViewWrapper.vue'
import ImageGallery from '~/components/car/classifieds/view/partials/ImageGallery.vue'
import CBackToTop from '~/components/shared/configurable/CBackToTop.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import FloatingUtilButtons from '~/components/shared/classified/view/FloatingUtilButtons.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import HeadService from '~/services/HeadService'
import { useNamespacedStore } from '~/compositions/store'
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount,
  useStore
} from '@nuxtjs/composition-api'
import { ClassifiedViewVariant } from '~/models/classified/view/variant'
import { preconnectLink } from '~/factories/head'
import { USER_NS } from '~/store/modules/shared/user/state'
import { SET_SHOW_CONTACT } from '~/store/modules/shared/classifieds/view/mutation-types'

export default defineComponent({
  components: {
    CShimmer,
    FloatingUtilButtons,
    ImageGallery,
    CBreadcrumbs,
    ViewWrapper,
    CBackToTop
  },
  asyncData({ store, route }) {
    return store.dispatch(`${CLASSIFIED_VIEW_NS}/createClassifiedView`, {
      slugOrId: route.params.slugOrId,
      variant: ClassifiedViewVariant.DEFAULT
    })
  },
  setup() {
    const {
      state: viewState,
      getters: viewGetters,
      commit: viewCommit,
      dispatch: viewDispatch
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)

    const breadcrumbs = computed(() => viewState.page?.breadcrumbs)
    const classified = computed(() => viewState.classified)
    const shortVideos = computed(() => viewGetters('getShortVideos'))

    const refs = computed(() => viewState.refs)

    const store = useStore()

    const unsubscribe = store.subscribeAction({
      after: async action => {
        if (!process.client) {
          return
        }
        if (action.type === `${USER_NS}/loadUser`) {
          await viewDispatch('loadClassifiedView')
          // also reset the contact form
          viewCommit(SET_SHOW_CONTACT, false)
          await nextTick()
          viewCommit(SET_SHOW_CONTACT, true)
        }
      }
    })

    onBeforeUnmount(() => {
      unsubscribe()
    })

    return { breadcrumbs, refs, classified, shortVideos }
  },
  head() {
    const { view: viewStore } = this.$store.state.classifieds
    const headService = this.$dep(HeadService)
    const { page, refs } = viewStore
    const { title, metadata } = page

    return headService.createHead({
      title: title || refs?.title,
      meta: headService.formatBackendMeta(metadata),
      link: [preconnectLink(viewStore.seoUrl, true, 'canonical')]
    })
  }
})
